import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Cấu hình Interceptor để tự động thêm token vào mỗi request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('app_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- BỔ SUNG: Interceptor để NHẬN phản hồi ---
api.interceptors.response.use(
  // Nếu phản hồi thành công, không làm gì cả
  (response) => {
    return response;
  },
  // Nếu phản hồi có lỗi
  (error) => {
    // Kiểm tra nếu đó là lỗi 401 Unauthorized
    if (error.response && error.response.status === 401) {
      // Xóa token và thông tin người dùng không hợp lệ
      localStorage.removeItem('app_token');
      localStorage.removeItem('user');
      
      // Chuyển hướng người dùng về trang đăng nhập
      // Dùng window.location.href để refresh lại toàn bộ trạng thái của app
      window.location.href = '/login';
    }
    
    // Trả về lỗi để các hàm gọi API khác có thể xử lý nếu cần
    return Promise.reject(error);
  }
);

export default api;